import type { LeaderboardMenuItem } from '../components/Leaderboard/LeaderboardMenu/LeaderboardMenu.types';
import type { CampaignEntry } from '../state/CampaignsSlice/types';
import type { DynamicCampaignSummary, StrapiImageType } from '../types';

const STRAPI_URL = import.meta.env.REACT_APP_STRAPI_URL ?? '';

export function getCampaignMenuItem(dynamicCampaign: DynamicCampaignSummary): LeaderboardMenuItem {
  const dynamicMenuItem: LeaderboardMenuItem = {
    id: dynamicCampaign?.campaignId,
    title: dynamicCampaign?.title,
    link: `/leaderboard/${dynamicCampaign?.campaignId}`,
    shortTitle: dynamicCampaign?.title,
    icon: resolveStrapiImage(dynamicCampaign.svgIcon),
  };

  return dynamicMenuItem;
}

export function resolveStrapiImage(image: StrapiImageType | undefined | null): string {
  if (!image?.url) {
    return '';
  }
  return image.url.startsWith('http') ? image.url : `${STRAPI_URL}${image.url}`;
}

export function getCampaignContent(campaignData: CampaignEntry) {
  const dynamicData = campaignData?.dynamicData?.data;

  return {
    dynamicData,
    dataDetails: dynamicData?.details,
    loadingDetails: campaignData?.dynamicData?.loading,
    dynamicArticle: dynamicData?.article,
  };
}
